import { keepPreviousData, queryOptions } from "@tanstack/react-query";
import { listAuditLogs, type AuditLogEntry, type AuditLogParams } from "@/lib/api/audit-logs";

export type AuditLogFilters = Pick<AuditLogParams, "action" | "entityType" | "dateFrom" | "dateTo">;

export const auditLogKeys = {
  all: ["audit-logs"] as const,
  lists: () => [...auditLogKeys.all, "list"] as const,
  list: (filters?: AuditLogFilters) => [...auditLogKeys.lists(), filters] as const,
};

/** One page of the log (keyset): `cursor` is the `nextCursor` of the page before, null for the first. */
export const auditLogsPageQueryOptions = (
  filters: AuditLogFilters,
  limit: number,
  cursor: string | null,
) =>
  queryOptions({
    queryKey: [...auditLogKeys.list(filters), limit, cursor],
    queryFn: () => listAuditLogs({ limit, cursor: cursor ?? undefined, ...filters }),
    placeholderData: keepPreviousData,
    staleTime: 0,
  });

export type { AuditLogEntry };
